import type { Types } from '../../types';
import type { ConnectedScheduleData } from '../../make-connected';
import { fromLocations } from './dependencies';
import { fromTeachers } from './teachers';
import { fromEvents } from './events';
import { parseSettings } from './settings';
import { parseDefault } from './default';
import { fromLockedTimes } from './locked-times';
import { parsePeriods } from './periods';
import { fromGroups } from './groups';
import { extractUniqueIntervals } from './intervals';
import { extractUniqueIndividuals } from './individuals';
import { fromLinkedEventsSets } from './linked-events-sets';

export function parseInput (
  data:    ConnectedScheduleData,
  options: Types.parsedToOptions = {}
): Types.scheduleData {

  const _settings         = data.settings;
  const _division         = data.division;
  const _groups           = data.groups           ?? [];
  const _teachers         = data.teachers         ?? [];
  const _locations        = data.locations        ?? [];
  const _events           = data.events           ?? [];
  const _lockedTimes      = data.lockedTimes      ?? [];
  const _courses          = data.courses          ?? [];
  const _persons          = data.persons          ?? [];
  const _periods          = data.periods          ?? [];
  const _linkedEventsSets = data.linkedEventsSets ?? [];


  ////
  //// replace empty/null intervals with undefined
  ////
  [_groups, _teachers, /* _locations, */ _courses, _events, _lockedTimes].forEach(entities => {
    entities.forEach(entity => {
      if      (entity.intervals && entity.intervals.length == 0) entity.intervals = undefined;
      else if (entity.intervals === null                       ) entity.intervals = undefined;
    });
  });

  const _fromEvents      = fromEvents     (_events,      _settings, options);
  const _fromLockedTimes = fromLockedTimes(_lockedTimes, _settings, options);

  const presentEventIds = new Set(_fromEvents.events.map(x => x.id));

  const linkedEvents = fromLinkedEventsSets(_linkedEventsSets, _settings, presentEventIds, options);

  const out: Types.scheduleData = {
    settings: parseSettings(_settings),
    default:  parseDefault (_settings, options),

    periods:   parsePeriods(_periods, _division, options),
    intervals: extractUniqueIntervals(_settings, _groups, _teachers, _courses, _events, _lockedTimes, options),

    dependencies: fromLocations(_locations, _settings, options),

    groups: [
      ...fromGroups  (_groups, _settings, options),
      ...fromTeachers(_teachers, _settings, options)
    ],

    individuals: extractUniqueIndividuals(_persons, _courses, _events, _lockedTimes, options),

    blockedTimes: _fromLockedTimes.blockedTimes,

    events: [
      ..._fromEvents.events,
      ..._fromLockedTimes.events
    ],

    activities: [
      ..._fromEvents.activities,
      ..._fromLockedTimes.activities
    ],

    linkedEvents: linkedEvents,

    unitableEvents: [],
  };
  return out;
};